import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";

import Context from "../context";

export default function ModeSwitch() {
	const { state, actions } = useContext(Context);

	const onClick = () => {
		actions.onChangeViewType(!state.isMobile);
	};

	return (
		<ToggleButtonGroup
			value={state.isMobile ? "phone" : "laptop"}
			onChange={(_e, value) => value !== null && onClick()}
			aria-label='device'
			sx={{ position: "absolute", top: 0, right: 0, m: 9, zIndex: 100 }}
		>
			<ToggleButton value='laptop' aria-label='laptop' sx={{ p: 1 }}>
				<Iconify icon='ic:baseline-laptop' width={16} />
			</ToggleButton>
			<ToggleButton value='phone' aria-label='phone' sx={{ p: 1 }}>
				<Iconify icon={"ic:baseline-phone-android"} width={16} />
			</ToggleButton>
		</ToggleButtonGroup>
	);
}
